import { useEffect } from 'react';

const useAnalytics = () => {
  useEffect(() => {
    // Track page view on component mount
    if (window.gtag) {
      window.gtag('event', 'page_view');
    }
  }, []);

  const trackEvent = (eventName, eventParams = {}) => {
    if (window.gtag) {
      window.gtag('event', eventName, eventParams);
    }
  };

  return { trackEvent };
};

export default useAnalytics; 